module.exports = __webpack_public_path__ + "img/Canis_minor.aaac579d.png";